export const GET_STOCK = "GET_STOCK";
export const GET_STOCK_FAILURE = "GET_STOCK_FAILURE";
export const GET_STOCK_REQUEST = "GET_STOCK_REQUEST";
export const CREATE_PAIN_SUCCESS = "CREATE_PAIN_SUCCESS";
export const CREATE_PAIN_FAILURE = "CREATE_PAIN_ERROR";
export const GET_PAIN_HISTORY = "GET_PAIN_HISTORY";
export const GET_PAIN_HISTORY_REQUEST = "GET_PAIN_HISTORY_REQUEST";
export const GET_PAIN_HISTORY_FAILURE = "GET_PAIN_HISTORY_FAILURE";
